import { create } from "zustand";
import { apiClient } from "../lib/apiClient";

export interface User {
  id: string;
  email: string;
  name: string;
  phone?: string;
  role: "customer" | "staff" | "admin";
  created_on: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  setCredentials: (user: User, token: string) => void;
  logout: () => void;
  initializeAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  token: localStorage.getItem("token"),
  isAuthenticated: !!localStorage.getItem("token"),
  setCredentials: (user, token) => {
    localStorage.setItem("token", token);
    set({ user, token, isAuthenticated: true });
  },
  logout: () => {
    localStorage.removeItem("token");
    set({ user: null, token: null, isAuthenticated: false });
  },
  initializeAuth: async () => {
    const { token, user } = get();
    // Only fetch if we have a token but no user data
    if (token && !user) {
      try {
        const userData = await apiClient<User>("/auth/me");
        set({ user: userData, isAuthenticated: true });
      } catch (error) {
        // Token is invalid, clear it
        localStorage.removeItem("token");
        set({ user: null, token: null, isAuthenticated: false });
      }
    }
  },
}));
